import React, { useEffect, useState } from "react";
import { ServiceSection } from "../../../AdminStyle.styled";
import { Row, Col, Button, Table, Modal, Tag } from "antd";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  DeleteRawMaterialInventory,
  GetRawMaterialsInventory,
  GetOneConfiguredServices,
  UpdateRawMaterialInventory,
  CreateRawMaterialInventory,
  GetAllRawMaterials,
} from "../../../../../../redux/actions/adminActions";
import { Delete, Edit, Add } from "@mui/icons-material";
import CreateRawMaterialModal from "./CreateRawMaterialsModal";
import {
  formatDateObjectHandler,
  formatNumber,
  priceFormat,
} from "../../../../../../utils";

const RawMaterials = (props) => {
  const {
    CreateRawMaterialInventory,
    UpdateRawMaterialInventory,
    GetRawMaterialsInventory,
    DeleteRawMaterialInventory,
    allRawMaterialsInventory,
    GetAllRawMaterials,
    allRawMaterials,
    my_roles,
    user_details,
  } = props;

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [formMode, setFormMode] = useState("CREATE_MODE");
  const [rawMaterialsRecord, setRawMaterialsRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: allRawMaterialsInventory?.length,
  });

  const editRecord = async (record) => {
    setRawMaterialsRecord(record);
    setVisible(true);
    setFormMode("UPDATE_MODE");
  };

  const deleteRecord = (record) => {
    Modal.confirm({
      title: "Do you want to delete this record?",
      content: "Click yes to proceed",
      okText: "Delete",
      loading: deleteLoading,
      okType: "danger",
      async onOk() {
        setDeleteLoading(true);
        const res = await DeleteRawMaterialInventory(record.id);
        if (res.success) {
          setDeleteLoading(false);
          toast.success(res.message, {
            pauseOnHover: false,
          });
        } else {
          toast.info(res.message, {
            pauseOnHover: true,
          });
        }
      },
      onCancel() {
        setDeleteLoading(false);
        return false;
      },
    });
  };
  const CreateService = () => {
    setVisible(true);
    setFormMode("CREATE_MODE");
    setRawMaterialsRecord(null);
  };

  const closeModal = () => {
    setVisible(false);
    setFormMode("CREATE_MODE");
    setRawMaterialsRecord(null);
  };

  const privileges = my_roles[0]?.role?.privileges;

  const recordColumn = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Raw Material",
      dataIndex: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
      render: (_text, record) => <>{formatNumber(record?.quantity)}</>,
    },
    {
      title: "Cost",
      dataIndex: "cost",
      align: "center",
      render: (_text, record) => <>{priceFormat(record?.cost)}</>,
    },
    {
      title: "Date Created",
      dataIndex: "date_created",
      align: "center",
      render: (_text, record) => (
        <>
          {formatDateObjectHandler(record.date_created, "Do MMM YYYY")} <br />
        </>
      ),
    },
    // {
    //   title: "action",
    //   dataIndex: "action",
    //   align: "center",
    //   render: (_text, record) => (
    //     <>
    //       <div className="actiontable">
    //         {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    //         {privileges?.includes("inventory.edit_inventory") && (
    //           <button className="eid" onClick={() => editRecord(record)}>
    //             <Edit />
    //           </button>
    //         )}
    //         {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    //         {privileges?.includes("inventory.delete_inventory") && (
    //           <button className="del" onClick={() => deleteRecord(record)}>
    //             <Delete />
    //           </button>
    //         )}
    //       </div>
    //     </>
    //   ),
    // },
  ];
  useEffect(() => {
    const getRawMaterialsRecords = async () => {
      setLoading(true);
      const res = await GetRawMaterialsInventory();
      setLoading(false);
      if (!res.success) {
        setLoading(false);
        toast.error(`Error`);
      }
    };
    getRawMaterialsRecords();
  }, [GetRawMaterialsInventory]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };
  return (
    <ServiceSection>
      {user_details?.is_staff ||
        (privileges?.includes("inventory.add_inventory") && (
          <Row>
            <Col xs={24}>
              <div style={{ textAlign: "right", marginBottom: "15px" }}>
                <Button
                  onClick={CreateService}
                  icon={<Add style={{ marginRight: "8px" }} />}
                  type="primary"
                >
                  {" "}
                  Add Inventory
                </Button>
              </div>
            </Col>
          </Row>
        ))}

      <Table
        rowKey="id"
        style={{ overflowX: "auto" }}
        loading={loading}
        columns={recordColumn}
        dataSource={allRawMaterialsInventory?.slice(
          (pagination.current - 1) * pagination.pageSize,
          pagination.current * pagination.pageSize
        )}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: false,
          showQuickJumper: false,
        }}
        onChange={handleTableChange}
      />
      <CreateRawMaterialModal
        visible={visible}
        closeModal={closeModal}
        formMode={formMode}
        one_raw_material_inventory={rawMaterialsRecord}
        CreateRawMaterialInventory={CreateRawMaterialInventory}
        UpdateRawMaterialInventory={UpdateRawMaterialInventory}
        GetAllRawMaterials={GetAllRawMaterials}
        allRawMaterials={allRawMaterials}
      />
    </ServiceSection>
  );
};

const mapStateToProps = (state) => {
  return {
    allRawMaterialsInventory: state.adminReducer.allRawMaterialsInventory,
    allRawMaterials: state.adminReducer.allRawMaterials,
    one_service: state.adminReducer.one_service,
    my_roles: state.userManagementReducer.my_roles,
    user_details: state.authReducer.user_details,
  };
};

export default connect(mapStateToProps, {
  UpdateRawMaterialInventory,
  CreateRawMaterialInventory,
  GetRawMaterialsInventory,
  DeleteRawMaterialInventory,
  GetOneConfiguredServices,
  GetAllRawMaterials,
})(RawMaterials);
